import React from 'react'
import { NavLink } from 'react-router-dom'
import { getText } from '../TextLabels'
import styles from './BackToLogin.module.scss'

const BackToLogin = () => (
  <div className={styles.backToLogin}>
    <NavLink data-cy="back-link" to="/">
      {getText('default.back')}
    </NavLink>
  </div>
)

export default BackToLogin
